import { render, staticRenderFns } from "./docUpload.vue?vue&type=template&id=94cf7e04&scoped=true"
import script from "./docUpload.vue?vue&type=script&lang=js"
export * from "./docUpload.vue?vue&type=script&lang=js"
import style0 from "./docUpload.vue?vue&type=style&index=0&id=94cf7e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cf7e04",
  null
  
)

export default component.exports